
export class PlatformFilterOptions {
    platformIds: Array<number>;
    dataOwnerIds: Array<number>;
}
